import c from 'classnames';
import * as React from 'react';
import { isFeatureEnabled } from '../../services/Features';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export default function PageStatic({ children, className }: Props) {
    // TODO when removing feature flag: remove PageStatic completely
    if (isFeatureEnabled('FEATURE_layoutRefresh')) {
        return <>{children}</>;
    }
    return <div className={c('page_static', className)}>{children}</div>;
}
